import React, { useEffect } from 'react';
import { AppDispatch, RootState } from '@/stores/store';
import { removeNotification } from '@/stores/notificationSlice';
import { useDispatch, useSelector } from "react-redux";
import Lucide from "@/components/Base/Lucide";
import { useTranslation } from "react-i18next";

const Main = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch<AppDispatch>();
    const notifications = useSelector((state: RootState) => state.notification.notifications);
    useEffect(() => {
        const timeoutIds = notifications.map((notification) =>
            setTimeout(() => {
                dispatch(removeNotification(notification._id));
            }, 5000) // Auto-remove notification after 5 seconds
        );
        return () => {
            timeoutIds.forEach((timeoutId) => clearTimeout(timeoutId));
        };
    }, [notifications, dispatch]);

    return (
        <div className="fixed bottom-2.5 right-2.5 flex flex-col gap-3 w-1/4 3xl:w-1/5 z-50">
            {notifications.map((notification) => (
                <div
                    key={notification._id}
                    className="relative py-5 pl-5 pr-14 bg-white border border-slate-200/60 rounded-lg shadow-xl dark:bg-darkmode-600 dark:text-slate-300 dark:border-darkmode-600"
                >
                    <div className="ml-4 mr-4">
                        <div className="font-medium">{t("guestCalling")}</div>
                        <div className="mt-1 text-slate-500">
                            {t("message")} : {notification.message ? notification.message : t("noMessage")}
                        </div>
                        <Lucide
                            icon={"X"}
                            className="absolute top-5 right-5"
                            onClick={() => dispatch(removeNotification(notification._id))}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Main;